import '../jquery'

let ready_legacy_record_batch;

ready_legacy_record_batch = function () {
  return $("body").on("submit", ".records_batch_form", function (e) {
    let form;
    e.preventDefault();
    e.stopPropagation();
    form = new FormData($(this)[0]);
    $('input.records-check[type="checkbox"]:checked').map(function () {
      return form.append('ids[]', $(this).data('id'));
    });
    return $.ajax({
      url: $(this).attr("action"),
      method: "POST",
      processData: false,
      contentType: false,
      data: form
    });
  });
};

$(document).ready(ready_legacy_record_batch);

$(document).on('turbo:load', ready_legacy_record_batch);